const ww = window.innerWidth
const wh = window.innerHeight

const s5BgW = wh * 2125 / 2436
const s5BgX = ww - s5BgW

const s5FatherX = 390 / 2125 * s5BgW + s5BgX
const s5MotherX = 620 / 2125 * s5BgW + s5BgX
const s5Me1X = 60 / 2125 * s5BgW + s5BgX
const s5Me2X = 64 / 2125 * s5BgW + s5BgX
const s5Talk1X = 260 / 2125 * s5BgW + s5BgX
const s5Talk2X = 868 / 2125 * s5BgW + s5BgX
const s5MoneyX = 531 / 2125 * s5BgW + s5BgX
const s5TextX = 88 / 2125 * s5BgW + s5BgX

const sprites = {
  s5_bg: {
    size: { mode: 'heightFit', height: 1 },
    position: { x: s5BgX / ww, y: 0 },
    anchor: 'topLeft'
  },
  s5_father: {
    size: { mode: 'heightFit', height: 0.383 },
    position: { x: s5FatherX / ww, y: 0.144 },
    anchor: 'topLeft'
  },
  s5_mother: {
    key: 's5_mother1',
    size: { mode: 'heightFit', height: 0.495 },
    position: { x: s5MotherX / ww, y: 0.402 },
    anchor: 'topLeft'
  },
  s5_me1: {
    size: { mode: 'heightFit', height: 0.438 },
    position: { x: s5Me1X / ww, y: 0.535 },
    anchor: 'topLeft'
  },
  s5_me2: {
    size: { mode: 'heightFit', height: 0.43 },
    position: { x: s5Me2X / ww, y: 0.545 },
    anchor: 'topLeft'
  },
  s5_money: {
    size: { mode: 'heightFit', height: 0.136 },
    position: { x: s5MoneyX / ww, y: 0.654 },
    anchor: 'bottomLeft'
  },
  s5_textnew: {
    size: { mode: 'heightFit', height: 0.427 },
    position: { x: s5TextX / ww, y: 0.14 },
    anchor: 'topLeft'
  },
  s5_talk1: {
    size: { mode: 'heightFit', height: 0.383 },
    position: { x: s5Talk1X / ww, y: 0.536 },
    anchor: 'bottomRight'
  },
  s5_talk2: {
    size: { mode: 'heightFit', height: 0.249 },
    position: { x: s5Talk2X / ww, y: 0.426 },
    anchor: 'bottomLeft'
  }
}

export default sprites



// WEBPACK FOOTER //
// ./src/assets/scenes/s5/sprites.js